import {useQuery} from '@tanstack/react-query';

import {getReferralProgress} from '../api';
import {QUERY__REFERRAL_PROGRESS} from '../queryKeys';

export const useGetReferralProgress = (userId: string) =>
  useQuery({
    queryKey: [QUERY__REFERRAL_PROGRESS, userId],
    queryFn: () => getReferralProgress(userId),
    enabled: !!userId,
  });
